export const CharacterCount = (item: number, max: number, update: (param: number) => void) => {
  return update(max - item);
}
